import { render, staticRenderFns } from "./ControlButtons.vue?vue&type=template&id=1592be98&scoped=true&"
import script from "./ControlButtons.vue?vue&type=script&lang=ts&"
export * from "./ControlButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ControlButtons.vue?vue&type=style&index=0&id=1592be98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1592be98",
  null
  
)

export default component.exports